import { useEffect, useRef, useState } from 'react';
import './Layout.scss';
import profile from '../assets/image/userProfile.png';
import notification from '../assets/image/notification.svg';
import setting from '../assets/image/setting.svg';
import Button from '../component/ui/Button';
import { useNavigate, useParams } from 'react-router-dom';
import Moment from 'react-moment';
import Clock from 'react-live-clock';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUserInfo, setAuthToken, setIsOnboardingCompleted } from '../store/action/userInfo';
import GlobalSearch from '../component/globalSearch/GlobalSearch';
import collapse from '../assets/image/sidebar/collapseSidebar.svg';
import logo from '../assets/image/PharmaNex_small.svg';
import expand from '../assets/image/sidebar/expandSidebar.svg';
import { toast } from 'react-toastify';
import { getNotificationsUnreadCounts, updateStatusNotification } from '../services/dashboard';
import { useSocket } from '../context/socketContext';
import { formatTimeAgo } from '../pages/dashboard/utils';
import {
	clearNotification,
	updateNotifications,
	updateRecentNotifications,
} from '../store/action/notifications';

const Navbar = ({ collapsed, setCollapsed, inputRef }) => {
	const queueRef = useRef([]);
	const socket = useSocket();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const params = useParams();
	const { recent_notification: notifications, total_unread_counts: unreadCount } = useSelector(
		(state) => state.notifications,
	);
	const [isOpenNotificationModal, setIsOpenNotificationModal] = useState(false);
	const userDetails = useSelector((state) => state?.userInfo?.userInfo);
	const suburl = localStorage.getItem('suburl');

	const handleSignout = () => {
		localStorage.clear();
		dispatch(clearNotification());
		dispatch(setAuthToken({ authToken: null }));
		dispatch(setIsOnboardingCompleted({ isOnboardingCompleted: false }));
		navigate(`/`);
	};

	const shortCutNavigate = (path) => {
		navigate(path);
	};

	const handlehamburger = () => {
		let root = document.getElementById('root');
		root.classList.toggle('collapsed');
		setCollapsed(!collapsed);
	};

	const markReadNotification = async (ids = []) => {
		if (ids.length > 0) {
			try {
				const body = {
					status: 'is_read',
					value: true,
					ids: ids,
					mark_as_read: false,
				};

				await updateStatusNotification(body);
				dispatch(
					updateRecentNotifications({
						ids: ids,
					}),
				);
			} catch (error) {
				toast.error(error.response.message || 'Somenthing went wrong');
			}
		}
	};

	useEffect(() => {
		const userInfoDetails = () => {
			try {
				dispatch(fetchUserInfo()).then((res) => {
					if (res?.success) {
						localStorage.setItem('suburl', res?.data?.sub_domain);
					} else {
					}
				});
			} catch (error) {
				toast.error('Something went wrong while fetching user info!');
			}
		};
		setTimeout(() => {
			userInfoDetails();
		}, 300);
	}, []);

	useEffect(() => {
		async function handleFetchUnreadNotificationsCounts() {
			try {
				const { recent_notifications, unread_counts } = await getNotificationsUnreadCounts();
				dispatch(
					updateRecentNotifications({
						recent_notification: recent_notifications,
						total_unread_counts: unread_counts,
					}),
				);
			} catch (error) {}
		}
		handleFetchUnreadNotificationsCounts();
	}, []);

	useEffect(() => {
		if (!socket) return;

		const handleNotification = (data) => {
			if (data && data.id) {
				queueRef.current.push(data);
			}
		};

		socket.on('notification', handleNotification);

		const interval = setInterval(() => {
			if (queueRef.current.length > 0) {
				const newNotificationBatch = queueRef.current;
				queueRef.current = [];

				const merged = [...newNotificationBatch, ...notifications];
				const unique = merged.filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
				const recent_notification = unique.slice(0, 5);

				dispatch(
					updateNotifications({
						notifications: newNotificationBatch,
						recent_notification: recent_notification,
						total_unread_counts: newNotificationBatch.length,
					}),
				);
			}
		}, 500);

		return () => {
			socket.off('notification', handleNotification);
			clearInterval(interval);
		};
	}, [socket, dispatch]);

	return (
		<div className={collapsed ? 'navtop' : 'navtop'}>
			<div className="nav-container">
				<span className="align-items-center d-flex gap-4">
					<img
						src={!collapsed ? collapse : expand}
						width="20"
						alt=""
						onClick={handlehamburger}
					/>
					<GlobalSearch inputRef={inputRef} />
				</span>

				<div className="right-details">
					<span className="currentTime mt-1">
						<Moment
							local
							format="MMMM, DD, YYYY | "
						></Moment>
						<span>
							<Clock
								format={'hh:mm:ss A'}
								timeZone={'Asia/Kolkata'}
								ticking={true}
							/>
						</span>
					</span>
					<span className="welcomeText">
						Hey!
						<span className="currentName">Welcome! {userDetails?.data?.first_name}</span>
					</span>
					<div className="dropdown-action">
						<a
							href="#"
							id="more-action"
							data-bs-toggle="dropdown"
							aria-expanded="false"
						>
							<Button
								type="button"
								add
								className="btn-primary addBtn"
							/>
						</a>
						<div
							className="dropdown-menu dropdown-menu-end"
							aria-labelledby="more-action"
						>
							<div className="d-flex">
								<div className="col-4 more-actions-list">
									<div className="section-title">GENERAL</div>
									<ul className="action-menu">
										<li
											className="action-menu-item"
											onClick={() => shortCutNavigate(`/user/${suburl}/product-create`)}
										>
											+ Add Product
										</li>
										<li className="action-menu-item">+ Add Users</li>
										<li
											className="action-menu-item"
											onClick={() => shortCutNavigate(`/user/${suburl}/group`)}
										>
											+ Items Groups
										</li>
										<li
											className="action-menu-item"
											onClick={() => shortCutNavigate(`/user/${suburl}/inventory-adjustment-crete`)}
										>
											+ Inventory Adjustments
										</li>
									</ul>
								</div>
								<div className="col-4 more-actions-list">
									<div className="section-title">GENERAL</div>
									<ul className="action-menu">
										<li className="action-menu-item">+ Customer</li>
										<li className="action-menu-item">+ Delivery Challan</li>
										<li className="action-menu-item">+ Invoices</li>
										<li className="action-menu-item">+ Retail Invoice</li>
										<li className="action-menu-item">+ Sales Order</li>
										<li className="action-menu-item">+ Shipment</li>
										<li className="action-menu-item">+ Customer Payment</li>
										<li className="action-menu-item">+ Credit Notes</li>
									</ul>
								</div>
								<div className="col-4 more-actions-list">
									<div className="section-title">GENERAL</div>
									<ul className="action-menu">
										<li className="action-menu-item">+ Vendor</li>
										<li className="action-menu-item">+ Bills</li>
										<li className="action-menu-item">+ Purchase Orders</li>
										<li className="action-menu-item">+ Purchase Receives</li>
										<li className="action-menu-item">+ Vendor Payment</li>
										<li className="action-menu-item">+ Vendor Credits</li>
									</ul>
								</div>
							</div>
						</div>

						<ul
							className="dropdown-menu font-14"
							aria-labelledby="moreAction"
							style={{ minWidth: '240px' }}
						>
							<li>
								<a
									className="dropdown-item"
									href="#"
								>
									New project...
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									href="#"
								>
									Settings
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									href="#"
								>
									Profile
								</a>
							</li>
							<li>
								<hr className="dropdown-divider" />
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={handleSignout}
								>
									Sign out
								</a>
							</li>
						</ul>
					</div>
					<div className="d-inline">
						<div
							style={{ position: 'relative', cursor: 'pointer' }}
							onClick={() => {
								setIsOpenNotificationModal(!isOpenNotificationModal);
							}}
						>
							<img
								src={notification}
								alt="mdo"
								width="25"
								height="25"
							/>
							{unreadCount > 0 && (
								<span
									style={{
										display: 'flex',
										justifyContent: 'center',
										alignItems: 'center',
										position: 'absolute',
										top: 0,
										left: 10,
										background: '#F30104',
										color: 'white',
										borderRadius: '35%',
										fontSize: '10px',
										width: '25px',
										height: '20px',
									}}
								>
									{unreadCount > 99 ? '99+' : unreadCount}
								</span>
							)}
						</div>
						{isOpenNotificationModal && (
							<div className="notification-doggle-container">
								<div className="d-flex align-items-center border-bottom justify-content-between pt-4 px-3 fs-4 font-bold">
									<p>Notifications</p>
									<p
										className="fs-5 font-semibold cursor-pointer"
										style={{ color: 'gray' }}
										onClick={() => {
											const ids = notifications
												.filter((data) => data.is_read === false)
												.map((item) => item.id);
											markReadNotification(ids);
										}}
									>
										Mark all as read
									</p>
								</div>
								{notifications.map((data) => (
									<div
										className="d-flex border-bottom gap-3 p-3 cursor-pointer"
										style={{ height: '80px', backgroundColor: data.is_read ? '' : '#daddec' }}
										onClick={() => {
											if (!data.is_read) {
												markReadNotification([data.id]);
											}
										}}
									>
										<div className="rounded-circle px-2 pt-1">
											<img
												src={logo}
												alt="mdo"
												width="24"
												height="24"
												className="rounded-circle"
											/>
										</div>
										<div style={{ width: '350px' }}>
											<div className="d-flex gap-3 align-items-center justify-content-between">
												<div className="notification-toggle-title fs-5">{data.title}</div>
												<div
													className="fs-6 fw-semibold"
													style={{ color: 'gray' }}
												>
													{formatTimeAgo(data.created_at)}
												</div>
											</div>
											<div
												className="notification-truncate-text fs-10"
												style={{ color: 'gray' }}
											>
												{data.description}
											</div>
										</div>
									</div>
								))}
								<div className="text-center">
									<div
										className="fs-5 fw-semibold rounded-4  p-3 text-primary cursor-pointer"
										onClick={() => {
											setIsOpenNotificationModal(false);
											navigate(`/user/${params.suburl}/home`, { state: { tab: 'Notifications' } });
										}}
									>
										View all notifications
									</div>
								</div>
							</div>
						)}
					</div>

					<img
						src={setting}
						alt="mdo"
						width="25"
						height="25"
					/>

					<div className="dropdown text-end">
						<a
							href="#"
							style={{ padding: '4px 0' }}
							className="d-block link-dark text-decoration-none dropdown-toggle px-3"
							id="dropdownUser1"
							data-bs-toggle="dropdown"
							aria-expanded="false"
						>
							<img
								src={profile}
								alt="mdo"
								width="32"
								height="32"
								className="rounded-circle me-2"
							/>
						</a>
						<ul
							className="dropdown-menu font-14"
							aria-labelledby="dropdownUser1"
							style={{ minWidth: '240px' }}
						>
							<li>
								<a
									className="dropdown-item"
									href="#"
								>
									New project...
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									href="#"
								>
									Settings
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									href="#"
								>
									Profile
								</a>
							</li>
							<li>
								<hr className="dropdown-divider" />
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={handleSignout}
								>
									Sign out
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Navbar;
